<template>
  <div class="passwordCheck">
    <mu-flexbox align="baseline">
      <mu-flexbox-item>
        <div class="pw-rules" v-if="isPasswordLengthValid !== false">
          <img src="../../../static/pw/tick_active" alt="" v-if="isPasswordLengthValid === true">
          <img src="../../../static/pw/tick_error" alt="" v-if="isPasswordLengthValid === 'error'">
          <span :class="{active: isPasswordLengthValid === true, error: isPasswordLengthValid === 'error'}">Password must not be more than <strong> {{maxCharacter}} characters</strong></span>
        </div>

      </mu-flexbox-item>

    </mu-flexbox>
  </div>
</template>

<script>
    export default {
        name: "PasswordLimitValidation.vue",
        props: {
          password: {
            type: String,
            default:() => null
          }
        },
        data() {
          return {
            isPasswordLengthValid: false,
            maxCharacter: 64,
          }
        },
        watch: {
          'password': function () {
            let self = this;
            const pw = this.password;
            if(pw.length <= self.maxCharacter) {
              this.isPasswordLengthValid = true
            } else {
              this.isPasswordLengthValid = 'error'
            }
          },
        },
    }

</script>

<style lang="less">
  .passwordCheck {
    margin: 0 0 10px;
    padding: 0 5px;
    .pw-rules {
      margin: 15px 0;
      img {
        vertical-align: middle;
        padding-right: 10px;
      }
      span {
        vertical-align: middle;
        font-size: 1em;
        line-height: 1.5;
        color: #000;
        font-family: 'Poppins', Arial, sans-serif;
        &.active {
          opacity: 0.3;
        }
        &.error {
          color: #d9140d;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PasswordLimitValidation.vue?97644b72